import { useState, useEffect } from "react";
import { Size } from "@/shared/types";

export function useResizeObserver(ref: React.RefObject<HTMLElement>) {
  const [observedSize, setObservedSize] = useState<Size>({});

  useEffect(() => {
    if (ref?.current == null) return;
    const observer = new ResizeObserver(([entry]) => {
      setObservedSize({
        width: entry.borderBoxSize?.[0]?.inlineSize,
        height: entry.borderBoxSize?.[0]?.blockSize,
      });
    });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return { observedSize };
}
